/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Refund_Err_Amount_MaxInputs */

const vi_refund_err_amount_max = /** @type {(inputs: Refund_Err_Amount_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Số tiền hoàn tối đa ${i?.max} đ`)
};

/**

* @param {Refund_Err_Amount_MaxInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const refund_err_amount_max = /** @type {((inputs: Refund_Err_Amount_MaxInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refund_Err_Amount_MaxInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_refund_err_amount_max(inputs)
});